export default __webpack_public_path__ + "static/media/leftImg.ad84a3b3.png";